import React from 'react'
import { SvgIcon } from '../svg-icon'

import styles from './no-notification-found-illustration.module.css'

/**
 * Define default props as fallback. See SvgIcon base className for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    keepPathColor: true,
    viewBoxSize: 160
}

/**
 * Stateless function representing a no notification found illustration.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <NoNotificationFoundIllustration width={160} />
 */
const NoNotificationFoundIllustration = props => (
    <SvgIcon {...props}>
        <path
            className={styles['bell-background']}
            d="M145.6 78.4C145.6 114.629 116.23 144 80.0004 144C43.7711 144 14.4004 114.629 14.4004 78.4C14.4004 42.1707
            43.7711 12.8 80.0004 12.8C116.23 12.8 145.6 42.1707 145.6 78.4ZM19.2004 15.4667C17.4351 15.4667 16.0004 16.9014
            16.0004 18.6667C16.0004 20.432 17.4351 21.8667 19.2004 21.8667C20.9657 21.8667 22.4004 20.432 22.4004
            18.6667C22.4004 16.9014 20.9657 15.4667 19.2004 15.4667ZM122.134 16C121.547 16 121.067 16.48 121.067
            7.0667C121.067 17.6534 121.547 18.1334 122.134 18.1334C122.72 18.1334 123.2 17.6534 123.2 17.0667C123.2 16.48
            122.72 16 122.134 16Z"
        />
        <path
            className={styles['dots']}
            d="M35.1995 146.133C38.1451 146.133 40.5329 143.746 40.5329 140.8C40.5329 137.854 38.1451 135.467 35.1995
            135.467C32.254 135.467 29.8662 137.854 29.8662 140.8C29.8662 143.746 32.254 146.133 35.1995 146.133Z"
        />
        <path
            className={styles['background']}
            d="M155.733 76.8C155.733 87.36 147.093 96 136.533 96H125.333H123.2C120.267 96 117.867 98.4 117.867
            101.333C117.867 104.267 120.267 106.667 123.2 106.667H124.8H125.333V106.693C128.608 106.965 131.2
            109.728 131.2 113.067C131.2 116.587 128.32 119.467 124.8 119.467H20.2666C16.7466 119.467 13.8666
            116.587 13.8666 113.067C13.8666 109.547 16.7466 106.667 20.2666 106.667H23.4666H29.8666C32.7999
            106.667 35.1999 104.267 35.1999 101.333C35.1999 98.4 32.7999 96 29.8666 96H23.4666C12.9066 96
            4.2666 87.36 4.2666 76.8C4.2666 66.24 12.9066 57.6 23.4666 57.6H136.533C147.093 57.6 155.733 66.24
            155.733 76.8ZM122.667 43.7333C122.667 41.3867 120.747 39.4667 118.4 39.4667H43.7333C41.3866 39.4667 39.4666
            41.3867 39.4666 43.7333C39.4666 46.08 41.3866 48 43.7333 48H118.4C120.747 48 122.667 46.08 122.667
            43.7333ZM33.0666 43.7333C33.0666 41.3867 31.1466 39.4667 28.7999 39.4667H20.2666C17.9199 39.4667 15.9999 41.3867
            15.9999 43.7333C15.9999 46.08 17.9199 48 20.2666 48H28.7999C31.1466 48 33.0666 46.08 33.0666 43.7333ZM153.6
            113.067C153.6 109.547 150.72 106.667 147.2 106.667H145.067C141.547 106.667 138.667 109.547 138.667
            113.067C138.667 116.587 141.547 119.467 145.067 119.467H147.2C150.72 119.467 153.6 116.587 153.6 113.067Z"
        />
        <path
            className={styles['dots']}
            d="M140.8 12.8C140.8 15.1573 138.891 17.0667 136.533 17.0667C134.176 17.0667 132.267 15.1573 132.267
            12.8C132.267 10.4427 134.176 8.53333 136.533 8.53333C138.891 8.53333 140.8 10.4427 140.8 12.8ZM111.467
            149.333C109.701 149.333 108.267 150.768 108.267 152.533C108.267 154.299 109.701 155.733 111.467 155.733C113.232
            155.733 114.667 154.299 114.667 152.533C114.667 150.768 113.232 149.333 111.467 149.333ZM30.3999 81.6C29.2213
            81.6 28.2666 82.5547 28.2666 83.7333C28.2666 84.912 29.2213 85.8667 30.3999 85.8667C31.5786 85.8667 32.5333
            84.912 32.5333 83.7333C32.5333 82.5547 31.5786 81.6 30.3999 81.6ZM131.733 67.7333C129.968 67.7333 128.533 69.168
            128.533 70.9333C128.533 72.6987 129.968 74.1333 131.733 74.1333C133.499 74.1333 134.933 72.6987 134.933
            70.9333C134.933 69.168 133.499 67.7333 131.733 67.7333Z"
        />
        <path
            className={styles['bell-and-letters']}
            d="M43.5573 28.4427H34.8267C33.776 28.4427 32.8533 27.856 32.4107 26.896C31.968 25.936 32.128 24.8533 32.8
            24.0533L39.696 16H33.776C32.8 16 32 15.2 32 14.224C32 13.248 32.8 12.448 33.776 12.448H41.616C42.6667 12.448
            43.5893 13.0347 44.032 13.9947C44.4747 14.9547 44.3147 16.0373 43.6427 16.8373L36.7467 24.8907H43.5573C44.5333
            24.8907 45.3333 25.6907 45.3333 26.6667C45.3333 27.6427 44.5333 28.4427 43.5573 28.4427ZM57.776
            36.4427H50.7893C49.92 36.4427 49.152 35.9467 48.7787 35.1627C48.4053 34.3787 48.528 33.472 49.0827 32.8L54.9333
            25.776H49.776C49.0453 25.776 48.4427 25.1733 48.4427 24.4427C48.4427 23.712 49.0453 23.1093 49.776
            23.1093H55.872C56.7413 23.1093 57.5093 23.6053 57.8827 24.3893C58.256 25.1733 58.1333 26.08 57.5787 26.752L51.7333
            33.776H57.776C58.5067 33.776 59.1093 34.3787 59.1093 35.1093C59.1093 35.84 58.5067 36.4427 57.776 36.4427ZM43.5573
            42.6667H37.5093C36.976 42.6667 36.48 42.3467 36.2827 41.8507C36.0693 41.3547 36.192 40.784 36.5653 40.3947L41.4027
            35.5573H37.3333C36.8373 35.5573 36.4427 35.168 36.4427 34.6667C36.4427 34.1653 36.832 33.776 37.3333
            33.776H42.4907C43.024 33.776 43.52 34.096 43.7173 34.592C43.9307 35.088 43.808 35.6587 43.4347 36.048L38.5973
            40.8853H43.5573C44.0533 40.8853 44.448 41.2747 44.448 41.776C44.4427 42.2773 44.0533 42.6667 43.5573
            42.6667ZM110.933 100H107.2V78.9333V76.2667V68.2667C107.2 55.312 98.0213 44.4053 85.8453 41.712C85.856
            41.584 85.8667 41.4613 85.8667 41.3333C85.8667 38.0907 83.2427 35.4667 80 35.4667C76.7573 35.4667 74.1333
            38.0907 74.1333 41.3333C74.1333 41.4613 74.144 41.584 74.1547 41.712C61.9787 44.4053 52.8 55.312 52.8
            68.2667V76.2667V78.9333V100H49.0667C47.3067 100 45.8667 101.44 45.8667 103.2C45.8667 104.96 47.3067
            106.4 49.0667 106.4H70.4C70.4 111.701 74.6987 116 80 116C85.3013 116 89.6 111.701 89.6 106.4H110.933C112.693
            106.4 114.133 104.96 114.133 103.2C114.133 101.44 112.693 100 110.933 100Z"
        />
        <path
            className={styles['background']}
            d="M80.0003 46.9333C68.267 46.9333 58.667 56.5333 58.667
            68.2667V77.0667V82.6667V100H67.611H92.3897H101.334V82.6667V77.0667V68.2667C101.334 56.5333 91.7337
            46.9333 80.0003 46.9333ZM76.4803 72.224C74.843 73.84 72.3523 74.6507 69.867 74.6507C67.3817 74.6507 64.891
            73.84 63.2537 72.224C62.8323 71.808 62.8323 71.136 63.243 70.7147C63.659 70.2933 64.331 70.2934 64.7523
            70.704C67.2377 73.1574 72.5017 73.1574 74.987 70.704C75.4083 70.288 76.0803 70.2933 76.4963 70.7147C76.907
            71.136 76.9017 71.8133 76.4803 72.224ZM80.5337 85.6C78.4697 85.6 76.8003 85.5893 76.8003 84.0747C76.8003 82.56
            78.4697 81.3333 80.5337 81.3333C82.5977 81.3333 84.267 82.56 84.267 84.0747C84.267 85.5893 82.5977 85.6 80.5337
            85.6ZM97.819 72.224C96.1817 73.84 93.691 74.6507 91.2003 74.6507C88.7097 74.6507 86.2243 73.84 84.5817
            72.224C84.1603 71.808 84.1603 71.136 84.571 70.7147C84.987 70.2933 85.659 70.2934 86.0803 70.704C88.5657
            73.1574 93.8297 73.1574 96.315 70.704C96.7363 70.288 97.4083 70.2933 97.8243 70.7147C98.2403 71.136 98.235
            71.8133 97.819 72.224Z"
        />
    </SvgIcon>
)

NoNotificationFoundIllustration.defaultProps = defaultProps

export { NoNotificationFoundIllustration }
